import React from 'react';
import { Link } from 'react-router-dom';
import { trackCTAClick } from '../utils/analytics';
import './PersonaCrossSell.css';

const ALL = [
  {
    key: 'meal_planning',
    path: '/meal-planning',
    title: 'Meal Planning',
    blurb: 'Build smart weekly menus and shop with one tap.',
    icon: 'fa-utensils',
  },
  {
    key: 'fitness',
    path: '/fitness-training',
    title: 'Fitness Training',
    blurb: 'Workout programs, 2,000+ exercises, and tracking.',
    icon: 'fa-dumbbell',
  },
  {
    key: 'coaching',
    path: '/coaching',
    title: 'Coaching',
    blurb: 'Hire certified fitness and nutrition coaches.',
    icon: 'fa-user-tie',
  },
  {
    key: 'business',
    path: '/for-business',
    title: 'For Business',
    blurb: 'Run your PT, gym, or nutrition practice in one place.',
    icon: 'fa-briefcase',
  },
];

/**
 * Cross-persona link strip. Pass `current` to filter out the current page so
 * we only show the *other* personas. Used at the bottom of each persona
 * landing to improve internal link graph and time-on-site.
 */
const PersonaCrossSell = ({ current }) => {
  const items = ALL.filter((p) => p.key !== current);
  return (
    <section className="persona-cross-sell" aria-label="Other ways to use FreshFitLab">
      <h2>Other ways to use FreshFitLab</h2>
      <div className="persona-cross-sell-grid">
        {items.map((item) => (
          <Link
            key={item.key}
            to={item.path}
            className="persona-cross-sell-card"
            onClick={() => trackCTAClick(current || 'general', `cross_sell_${item.key}`)}
          >
            <div className="persona-cross-sell-icon">
              <i className={`fas ${item.icon}`}></i>
            </div>
            <h3>{item.title}</h3>
            <p>{item.blurb}</p>
            <span className="persona-cross-sell-arrow">
              Explore
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default PersonaCrossSell;
